.root {
  &[data-variant='card'] {
    border-radius: var(--toggle-radius, var(--mantine-radius-md));
    border-color: var(--mantine-color-gray-3);
    background-color: var(--mantine-color-white);
    color: var(--mantine-color-gray-8);

    &:hover:where(:not([data-disabled], [data-active])) {
      background-color: var(--mantine-color-gray-1);
    }

    &:where([data-active]):where(:not([data-disabled])) {
      border-color: var(--mantine-primary-color-6);
      /* Thickens the border to 2px without shifting the layout */
      box-shadow: inset 0 0 0 1px var(--mantine-primary-color-6);
      background-color: var(--mantine-primary-color-1);
      color: var(--mantine-primary-color-6);
    }
  }
}
